import React, { ReactNode } from 'react'
import styled from 'styled-components'

interface RadioProps {
  label?: ReactNode
  name: string
  value: string
}

const RadioButton = styled.input`
  display: inline-block;
  margin-right: 1rem;
  margin-bottom: 0;
  width: 1rem;
`

// Destructure checked from input to allow for defaultChecked to propagate to input field.
const Radio: React.FC<any> = ({ input: { checked, ...input }, label, ...props }: any) => {
  return (
    <div>
      <RadioButton type="radio" {...input} {...props} />
      <label htmlFor={input.value}>{label}</label>
    </div>
  )
}

export default Radio
